import React from 'react';
export var SortableTableContext = React.createContext({
    currentSortColumn: '',
    onColumnClicked: function () {
        /* no-op */
    },
});
export var ariaDirections = {
    asc: 'ascending',
    desc: 'descending',
};
//# sourceMappingURL=SortableTable.types.js.map